import type { FaireProductEntity } from "../../entity_types/product";

export const p_6hwgdb898q: FaireProductEntity = {
  token: "p_6hwgdb898q",
  type: "product",
  name: "Gingham Bow Patch Denim Jacket - Western Apparel",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/ad997fa1db5e2f60489dc136245e6884a11f517e856d883ec9ac767f809c8bd3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6bb83490275a16f9ff839961680da1e8a75b95b1d6dd0ac59f5d33e4bc58b84.jpeg",
    "https://cdn.faire.com/fastly/8d6cb63c2058e31f63bd9ecdc497969712c7dd4313217c72941ebaa53af0b965.jpeg",
    "https://cdn.faire.com/fastly/5b1f0d1f5d72dba3ea62d66794bec05542e59fdc4c5ca4b4cc49ef1ae27aca25.jpeg",
    "https://cdn.faire.com/fastly/0ac196e625b48c37beb9115eee0a1466f2189790a2b8a96c2b5fba58eeb80c75.jpeg",
  ],
  priceDollars: 44,
  description:
    "The Gingham Bow Patch Denim Jacket is a fun and trendy jacket for showing off your cowgirl spirit!\n\nFeatures:\n*Jacket Color: Denim\n*Gingham Bow Patch Color: Brown and white gingham with a glossy embroidered outline\n*Material: 85% Cotton/15% Polyester\n*Fit: Toddler Unisex; True to Size\n*Care: Hand wash only, do not iron, tumble dry, bleach or dry clean\n\nEach jacket is hand pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:19.993Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
